import React from 'react'
import type { InlineInputContentOptions, InlineInputProps } from '@ztechapps/webui.input'
import { NumberInlineInput } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'
import { formatMoney } from '@ztechapps/common.utils'
import { DiscountLabel } from '../DiscountLabel'

export const PriceInlineInput = (props: InlineInputProps) => {
  return (
    <NumberInlineInput
      label={'Selling / Discounted Price'}
      name="price"
      help={'The price that the customer will see and pay for.'}
      displayContent={(e, onClick, options: InlineInputContentOptions) => (
        <HorizontalStack gap={1} className="align-items-center">
          <div>{formatMoney(e)}</div>
          <DiscountLabel discountPercentage={options?.initialValues?.discountPercentage} />
        </HorizontalStack>
      )}
      validate={(e) => {
        if (e < 0) throw new Error('Price needs to be more than or equal to zero.')
      }}
      {...props}
    />
  )
}
